export default "__VITE_ASSET__cxkbPxyw__"